<template>
  <div class="study_layout">
    <s-breadcrumb :breadList="breadList"></s-breadcrumb>
    <div class="card">
      <div>
        <my-aside :studyInfo="studyInfo"></my-aside>
      </div>
      <main class="card_main">
        <keep-alive include="CouresPage">
          <router-view></router-view>
        </keep-alive>
      </main>
    </div>
  </div>
</template>
<script>
import myAside from './components/Aside'
import Breadcrumb from '@/components/tools/Breadcrumb'
import { feachStudyInfo } from '@/api/user'
export default {
  name: '',
  components: {
    's-breadcrumb': Breadcrumb,
    myAside
  },
  data() {
    return {
      breadList: [],
      studyInfo: {
        liveNum: 0,
        homeWorkNum: 0,
        learningTime: 0,
        themeNum: 0
      }
    }
  },
  computed: {},
  created() {
    this.feachStudyInfoAsync()
  },
  mounted() {},
  methods: {
    async feachStudyInfoAsync() {
      try {
        this.studyInfo = await feachStudyInfo()
      } catch (error) {
        console.log(error)
      }
    },
    tabClick(el) {
      this.breadList = []
      this.breadList.push({
        title: '学习中心',
        icon: 'fund',
        name: 'course'
      })
      this.breadList.push(el)
    }
  }
}
</script>
<style lang="less" scoped>
li {
  list-style: none;
}
.study_layout {
  height: 100%;
  width: 1200px;
  margin: 0 auto;
  // width: 100%;
  // padding: 0  120px 0 120px;
  background: #f5f8fa;
  color: #5e668d;
  padding-bottom: 50px;
  .ant-breadcrumb {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
  }
  .card {
    display: flex;
    height: calc(100% - 78px);
    min-height: 584px;
    border-radius: 15px;
    // .card_aside {
    //   width: 260px;
    //   height: 100%;
    //   padding: 15px;
    //   border-right: 1px solid #ced3dc;
    //   .aside_info {
    //     display: flex;
    //     flex-direction: column;
    //     align-items: center;
    //     h5 {
    //       margin: 12px 0;
    //       font-size: 16px;
    //       font-weight: bold;
    //     }
    //     p {
    //       font-size: 12px;
    //     }
    //   }
    //   .aside_data {
    //     display: flex;
    //     justify-content: space-between;
    //     .data_item {
    //         margin: 24px 0;
    //         text-align: center;
    //         h5 {
    //             margin-bottom: 10px;
    //             font-size: 16px;
    //             font-weight: bold;
    //         }
    //         p {
    //             font-size: 12px;
    //         }
    //     }
    //   }
    //   .aside_live_broadcast {
    //     display: flex;
    //     align-items: center;
    //     padding-top: 6px;
    //     padding-bottom: 22px;
    //     border-bottom: 1px solid #CED3DC;
    //     h3 {
    //         height: 100%;
    //         line-height: 100%;
    //         font-size: 16px;
    //     }
    //     .course {
    //         padding: 5px 6px;
    //         margin-left: 14px;
    //         color: #1564FF;
    //         background: #F5F6FA;
    //         border-radius: 10px;
    //         font-size: 12px;
    //     }
    //   }
    //   .aside_list {
    //     padding-top: 10px;
    //     .list_item {
    //         display: block;
    //         padding: 0 6px;
    //         margin-bottom: 10px;
    //         height: 40px;
    //         line-height: 40px;
    //         color: #5E668D;
    //         // background: #F5F6FA;
    //         cursor: pointer;
    //     }
    //     .router-link-active {
    //         border-radius: 3px;
    //         background: #F5F6FA;
    //         color: #1564FF;
    //     }
    //   }
    // }
    .card_main {
      flex: 1;
      width: 100%;
      padding: 15px;
      overflow: hidden;
      // margin-left: 22px;
      background: #fff;
      border-radius: 10px;
    }
  }
}
</style>
